<span class="w-8 md:w-13.5 flex justify-center" aria-hidden="true">...</span>
